import { PROJECT_CODE } from "../../constants";
export const NEED_CHECK_PAYLOAD_PATHNAME = {
  Suzhou: "suzhou",
  Xiaoyaoxiang: "Xiaoyaoxiang1",
  Xuepingxian: "xuepingxian",
};

export const PATHNAME_MAP_PROJECT_CODE = new Map([
  [NEED_CHECK_PAYLOAD_PATHNAME.Suzhou, PROJECT_CODE.Suzhou],
  [NEED_CHECK_PAYLOAD_PATHNAME.Xiaoyaoxiang, PROJECT_CODE.Xiaoyaoxiang],
  [NEED_CHECK_PAYLOAD_PATHNAME.Xuepingxian, PROJECT_CODE.Sichuan_Xueping],
]);

export const PROJECT_CODE_MAP_IMAGE_LIST = new Map([
  [
    PROJECT_CODE.Suzhou,
    [
      "https://pub-img.treewisdomhealth.com/suzhou_01.png",
      "https://pub-img.treewisdomhealth.com/suzhou_02.png",
      "https://pub-img.treewisdomhealth.com/suzhou-h5-2025-01-08-01.png",
      "https://pub-img.treewisdomhealth.com/suzhou_04.png",
    ],
  ],
  [
    PROJECT_CODE.Xiaoyaoxiang,
    [
      "https://pub-img.treewisdomhealth.com/small-medicine-cabinet-h5-00-0828.png",
      "https://pub-img.treewisdomhealth.com/small-medicine-cabinet-h5-01-0828.png",
      "https://pub-img.treewisdomhealth.com/small-medicine-cabinet-h5-02-0828.png",
      "https://pub-img.treewisdomhealth.com/small-medicine-cabinet-h5-03-0828.png",
    ],
  ],
  [
    PROJECT_CODE.Sichuan_Xueping,
    [
      "https://pub-img.treewisdomhealth.com/xuepingxian-h5-01.png",
      "https://pub-img.treewisdomhealth.com/xuepingxian-h5-02.png",
      "https://pub-img.treewisdomhealth.com/xuepingxian-h5-03.png",
      "https://pub-img.treewisdomhealth.com/xuepingxian-h5-04.png",
      "https://pub-img.treewisdomhealth.com/xuepingxian-h5-0827-05.png",
    ],
  ],
]);

/** 字段转换的映射 */
export const PROJECT_CODE_MAP_FIELD_MAP = new Map([
  [
    PROJECT_CODE.Sichuan_Xueping,
    new Map([
      ["userName", "insuredName"],
      ["mobile", "insuredPhone"],
      ["uid", "exteralUserId"],
    ]),
  ],
]);

function decodeUTF8Base64(str) {
  const result = decodeURIComponent(
    atob(str)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  console.log('result', result)
  return result
}

function urlSearchParamsToObject(params) {
  const obj = {};
  // 遍历所有参数键值对
  for (const [key, value] of params.entries()) {
    obj[key] = value;
  }
  return obj;
}

export const PROJECT_CODE_MAP_ENCRYPT_FUNC = new Map([
  [
    PROJECT_CODE.Sichuan_Xueping,
    (str) => urlSearchParamsToObject(new URLSearchParams(decodeUTF8Base64(str))),
  ],
]);

export const PROJECT_CODE_MAP_UN_ENCRYPT_FUNC = new Map([
  [
    PROJECT_CODE.Sichuan_Xueping,
    (search) => {
      const result = urlSearchParamsToObject(new URLSearchParams(search.replace('?payload=', '')));
      return result;
    },
  ],
]);
